import React from "react";

import { showDialogAsync } from "../../dialog-queue";
import { ConfirmDialog } from "../../dialog/confirm";
import { DontAskAgainCheckbox } from "../../dont-ask-again-checkbox";
import { REMEMBER_CLONE_SPREADS_SESSION_KEY } from "./constants";
import { labels } from "./labels";

export const showCloneSpreadDialog = async () => {
	return sessionStorage.getItem(REMEMBER_CLONE_SPREADS_SESSION_KEY)
		? true
		: showDialogAsync<boolean>(({ resolve }, { isOpen }) => (
				<ConfirmDialog
					cancelLabel={labels.cancel}
					titleLabel={labels.title}
					messageLabel={labels.message}
					isOpen={isOpen}
					okLabel={labels.confirm}
					onOk={() => resolve(true)}
					onCancel={() => resolve(false)}
				>
					<DontAskAgainCheckbox sessionKey={REMEMBER_CLONE_SPREADS_SESSION_KEY} />
				</ConfirmDialog>
		  ));
};
